export const layoutOptions = {
  'elk.algorithm': 'layered',
  'elk.direction': 'DOWN',
  // Layering + cycle + crossings
  'elk.layered.layering.strategy': 'NETWORK_SIMPLEX',
  'elk.layered.cycleBreaking.strategy': 'GREEDY',
  'elk.layered.crossingMinimization.strategy': 'LAYER_SWEEP',
  'elk.layered.crossingMinimization.semiInteractive': 'true',
  'elk.layered.thoroughness': '15', // higher = more time, fewer crossings
  // Node placement / ordering hints
  'elk.layered.nodePlacement.strategy': 'LONGEST_PATH',
  'elk.layered.nodePlacement.favorStraightEdges': 'true',
  'elk.layered.considerModelOrder': 'true',
  // Provide default port constraint (decision nodes override w/ explicit ports)
  'elk.layered.portConstraints': 'FIXED_ORDER',
  // Routing + spacing
  'elk.edgeRouting': 'ORTHOGONAL',
  'elk.spacing.nodeNode': '80',
  'elk.layered.layering.nodePromotion.maxIterations': '1',
  'elk.layered.spacing.edgeNodeBetweenLayers': '10',
  'elk.layered.spacing.edgeEdgeBetweenLayers': '20',
  'elk.layered.spacing.nodeNodeBetweenLayers': '80',
  'elk.spacing.edgeNode': '30',
  'elk.spacing.edgeEdge': '20',
  // Misc quality tweaks
  // 'elk.layered.mergeEdges': 'true',
  'elk.layered.compaction.postCompaction.strategy': 'NETWORK_SIMPLEX',
};
